<mat-toolbar class="subtitulo">Níveis da Turma</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        <mat-toolbar class="titulopartes">Dados</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <mat-form-field fxFlexOffset="20px" fxFlex="20%">
                <input #codigo
                       matInput 
                       maxlength="10"  
                       name="codigo" 
                       placeholder="Código" 
                       [(ngModel)]="nivelTurma.codigo" required>
                <!--input #codigo 
                       matInput 
                       maxlength="10" 
                       name="codigo" 
                       placeholder="Código" 
                       [(ngModel)]="nivelTurma.codigo"
                       pattern="[0-9]+$"
                       required-->
                <mat-hint align="end">{{codigo.value.length}} / 10</mat-hint>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <mat-form-field fxFlexOffset="20px" fxFlex="95%" appearance="outline">
                <mat-label>Descrição</mat-label>
                <textarea #descricao matInput name="descricao" 
                          [(ngModel)]="nivelTurma.descricao" 
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize" 
                          cdkAutosizeMinRows="5" 
                          maxlength="4000"></textarea>
                <mat-hint align="end">{{descricao.value.length}} / 4000</mat-hint>
            </mat-form-field>
        </div>        

        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
            fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()">
                Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                Limpar
            </button>
            <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                Cancelar
            </button>

        </div>
    </form>


</div>